export default __webpack_public_path__ + "static/media/SG-White-0002.55408549.png";